module.exports = __webpack_public_path__ + "img/bonus3.fccba3cc.png";